export const START_FUNCTION_NAME = 'start_function';
export const END_FUNCTION_NAME = 'end_function';
